import React from 'react';
import PropTypes from 'prop-types';
import StudentAccessFrequencySummary from './StudentAccessFrequencySummary';
import { toJS } from 'mobx';
import { StudentAccessFrequencyListService } from '../../services/CustomerSuccessKpiListService';
import { observer } from 'mobx-react';
import { get } from 'lodash';

class StudentAccessFrequencySummaryContainer extends React.Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    typeId: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    StudentAccessFrequencyListService.load();
  }

  render() {
    const data = toJS(StudentAccessFrequencyListService.getSummaryByType(this.props.type, this.props.typeId));
    return (
      <StudentAccessFrequencySummary
        isLoading={
          StudentAccessFrequencyListService.fetchCurrent.fetching ||
          StudentAccessFrequencyListService.fetchPrevious.fetching
        }
        currentValue={get(data, 'current')}
        previousValue={get(data, 'previous')}
        standardDeviationValue={get(data, 'currentStandardDeviation')}
        formatter={StudentAccessFrequencyListService.getFormattedValue}
      />
    );
  }
}

export default observer(StudentAccessFrequencySummaryContainer);
